import subString from "../../../utils/subString";

const TitleApplication = ({ substring }) => {
  const cekSubstring = (substring, application_name) => {
    if (substring) {
      return subString(`${application_name}`, 13);
    } else {
      return application_name;
    }
  };

  if (localStorage.getItem("general_setting")) {
    const application_name = JSON.parse(
      localStorage.getItem("general_setting")
    ).application_name;
    return cekSubstring(substring, application_name);
  } else {
    return cekSubstring(
      substring,
      window.__RUNTIME_CONFIG__.REACT_APP_NAME
    );
  }
};

export default TitleApplication;
